import { render, staticRenderFns } from "./AllDone.vue?vue&type=template&id=0f5887a2&scoped=true"
import script from "./AllDone.vue?vue&type=script&lang=js"
export * from "./AllDone.vue?vue&type=script&lang=js"
import style0 from "./AllDone.vue?vue&type=style&index=0&id=0f5887a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5887a2",
  null
  
)

export default component.exports